import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EBonusStatus } from 'shared/types/bonusStatus';
import type { IModal } from 'shared/types/features';
import { removeOpenModalFromUrl } from 'shared/utils/url';

const initialState: IModal = {
  status: EBonusStatus.Init,
  visible: false,
};

/* istanbul ignore next */
const modalSlice = createSlice({
  initialState,
  name: 'modal',
  reducers: {
    setVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;

      if (!action.payload) {
        removeOpenModalFromUrl();
      }
    },
  },
});

export const {
  reducer: modalReducer,
  actions: { setVisible },
} = modalSlice;
